import React from 'react';
import { Helmet } from 'react-helmet-async';

const JotformStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Certified Jotform Expert & Consultant",
    "description": "Professional Jotform development with 5+ years of experience. Certified partner creating advanced forms, automations, and integrations.",
    "provider": {
      "@type": "Person",
      "name": "Daniel Gadus"
    },
    "areaServed": ["Prague", "Czech Republic", "Denmark", "Slovakia"],
    "serviceType": ["Jotform Development", "Form Automation", "CRM Integration"],
    "offers": {
      "@type": "Offer",
      "name": "Free Jotform Audit",
      "description": "Comprehensive review of your current forms with optimization recommendations"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default JotformStructuredData;